import React, { type SetStateAction, type Dispatch } from 'react'
import HelpTutorial, { HelpTutorialSlide, useHelpTutorial } from '@fs/zion-help-tutorial'
import { useTranslation } from 'react-i18next'
import { type UseOverlayReturnOptions } from '@fs/zion-ui'
import connectImage from '../../../assets/onboarding/connect.svg'
import legacyImage from '../../../assets/onboarding/legacy.svg'
import shareImage from '../../../assets/onboarding/share.svg'
import searchImage from '../../../assets/onboarding/search.svg'

type HelpTutorial = UseOverlayReturnOptions & {
  shouldShowAd: boolean
  hideAdChecked: boolean
  setShouldShowAd: Dispatch<SetStateAction<boolean>>
  changeTutorialPreference: (newValue: unknown) => void
  changeHideAdCheckedTutorialPreference: (newValue: unknown) => void
}

export function AdminOnboardingOverview(): JSX.Element {
  const [t] = useTranslation()
  const helpTutorial: HelpTutorial = useHelpTutorial('tree-groups.admin-onboarding')

  return (
    <HelpTutorial
      tutorialTitle={t('groups.admin-onboarding.heading')}
      tutorialDescription={t('groups.admin-onboarding.description')}
      endHeader={false}
      {...helpTutorial}
    >
      <HelpTutorialSlide
        imageAlt=""
        imageSrc={connectImage}
        imgBleed
        heading={t('groups.connect-your-family.heading')}
        content={t('groups.gather-your-family.description')}
        headingSize="H4"
        contentSize="md"
      />
      <HelpTutorialSlide
        imageAlt=""
        imageSrc={shareImage}
        imgBleed
        heading={t('groups.share-and-protect.heading')}
        content={t('groups.share-memories.description')}
        headingSize="H4"
        contentSize="md"
      />
      <HelpTutorialSlide
        imageAlt=""
        imageSrc={legacyImage}
        imgBleed
        heading={t('groups.leave-a-legacy.heading')}
        content={t('groups.ensure-that-future.description')}
        headingSize="H4"
        contentSize="md"
      />
    </HelpTutorial>
  )
}

export function ResearcherAdminOnboardingOverview(): JSX.Element {
  const [t] = useTranslation()
  const helpTutorial: HelpTutorial = useHelpTutorial('tree-groups.admin-onboarding-researcher')

  return (
    <HelpTutorial
      tutorialTitle={t('groups.admin-onboarding.researcher.heading')}
      tutorialDescription={t('groups.admin-onboarding.researcher.description')}
      endHeader={false}
      {...helpTutorial}
    >
      <HelpTutorialSlide
        imageAlt=""
        imageSrc={connectImage}
        imgBleed
        heading={t('groups.admin-onboarding.researcher.slide1.heading')}
        content={t('groups.admin-onboarding.researcher.slide1.description')}
        headingSize="H4"
        contentSize="md"
      />
      <HelpTutorialSlide
        imageAlt=""
        imageSrc={searchImage}
        imgBleed
        heading={t('groups.admin-onboarding.researcher.slide2.heading')}
        content={t('groups.admin-onboarding.researcher.slide2.description')}
        headingSize="H4"
        contentSize="md"
      />
      <HelpTutorialSlide
        imageAlt=""
        imageSrc={legacyImage}
        imgBleed
        heading={t('groups.admin-onboarding.researcher.slide3.heading')}
        content={t('groups.admin-onboarding.researcher.slide3.description')}
        headingSize="H4"
        contentSize="md"
      />
    </HelpTutorial>
  )
}
